import { render, staticRenderFns } from "./RegistroUsuarios.vue?vue&type=template&id=4c27816a&scoped=true&"
import script from "./RegistroUsuarios.vue?vue&type=script&lang=js&"
export * from "./RegistroUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./RegistroUsuarios.vue?vue&type=style&index=0&id=4c27816a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27816a",
  null
  
)

export default component.exports